import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EstablishmentIsOpenService {
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  isEstablishmentOpen(apertura: string, cierre: string, isOpen: boolean): boolean {

    if (!isOpen) {
      return false;
    }

    // Si no estamos en el navegador, devolvemos false para evitar inconsistencias
    // entre la hora del servidor (SSR) y la hora del usuario.
    if (!this.isBrowser) {
      return false;
    }

    if (!apertura || !cierre) {
      return false;
    }
    try {
      const now = new Date();
      const currentTime = now.getHours() * 60 + now.getMinutes();

      // Procesar hora de apertura - tomar solo HH:mm del formato completo
      const [openTime] = apertura.split('.');  // Separar la parte de milisegundos
      const [openHours, openMinutes] = openTime.split(':');
      const openingTime = parseInt(openHours) * 60 + parseInt(openMinutes);

      // Procesar hora de cierre - tomar solo HH:mm del formato completo
      const [closeTime] = cierre.split('.');   // Separar la parte de milisegundos
      const [closeHours, closeMinutes] = closeTime.split(':');
      const closingTime = parseInt(closeHours) * 60 + parseInt(closeMinutes);


      // Evaluar la condición
      let isTimeOpen;
      if (closingTime < openingTime) {
        isTimeOpen = currentTime >= openingTime || currentTime <= closingTime;
      } else {
        isTimeOpen = currentTime >= openingTime && currentTime <= closingTime;
      }

      return isTimeOpen;
    } catch (error) {
      console.error('Error al procesar los horarios:', error);
      return false;
    }
  }

  formatTime(time: string | undefined): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'pm' : 'am';
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minutes} ${ampm}`;
  }


}
